interface MessageDataObject {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export type MessageDataString = string;

export type MessageData = MessageDataObject | MessageDataString;

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const parseMessageData = <T extends MessageDataObject = {}>(data: MessageData): T => {
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        } catch (_e) {
            return {} as T;
        }
    }

    return data as T;
};
